//#region src/components/ScalarTooltip/constants.ts
/** The ID of the tooltip element used to locate it in the DOM */
var ELEMENT_ID = "scalar-tooltip";
/** The class name of the tooltip element */
var ELEMENT_CLASS = "scalar-tooltip";
//#endregion
export { ELEMENT_CLASS, ELEMENT_ID };

//# sourceMappingURL=constants.js.map